global.atob = require("atob");
